import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'

import { Loader, Form, TextAreaInput } from '../../../UI'
import { validateRequired } from '../../../../libs/validation'
import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourWhatYouProvide.graphql'
import { NotificationManager } from 'react-notifications';

class WhereWillBe extends Component {
  state = {
    saving: false
  }

  componentDidMount() {
    this.setState({
      whatWeProvide: this.props.currentSteps.whatWeProvide || ''
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, updateSteps, history } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        whatWeProvide: values.whatWeProvide
      }
    }).then(() => {
      this.setState(
        {
          saving: false
        },
        () => {
          updateSteps()
          NotificationManager.success('What you provide updated', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            history.push(`/activity-steps/${data.allLocalTours[0].id}/need-to-bring`)
          } else {
            history.push('/activity-steps/need-to-bring')
          }
        }
      )
    }).catch(err=>NotificationManager.error('Error while updating what you provide', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving, whatWeProvide } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('what_you_provide')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <label className="steps-screen__form-input-label">{t('provide_description')}</label>
            <div className="form-input-example">{t('provide_spec')}</div>

            <TextAreaInput
              id="whatWeProvide"
              placeholder={''}
              initialValue={whatWeProvide}
              maxChars={300}
              validationFuncs={[validateRequired]}
              labelClass="steps-screen__form-input-label"
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(WhereWillBe)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MoreDetails/WhatYouProvide.jsx